
/* ============================================================
   DE VLUCHT — de kaartlijn wordt een dronevlucht door de tijd.
   Uitleg van de vier fasen staat in sections/donq-vlucht.liquid.
   Dit bestand laadt alleen op pagina's waar die sectie staat.
   ============================================================ */
(function(){
  const sectie = document.querySelector('[data-vlucht-sectie]');
  if (!sectie) return;
  const dataEl = document.getElementById('vluchtData');
  if (!dataEl) return;
  let D; try { D = JSON.parse(dataEl.textContent); } catch(e){ return; }
  if (!D.haltes || !D.haltes.length || !D.clips || !D.clips.length) return;

  const HALTES = D.haltes, CLIPS = D.clips, REIS_TOT = D.reisTot || 0.13;
/* DE REIS OVER DE LIJN.
   Groeien en kantelen gebeuren NIET na elkaar maar tegelijk: terwijl de rivier
   zich naar beneden tekent, zakt de camera er al langs mee omlaag. Je volgt de
   punt van de lijn terwijl hij getekend wordt, en hoe verder je komt hoe platter
   je erop kijkt — tot je erin zit. Eerst de lijn afmaken en dán pas induiken
   voelde als twee losse bewegingen; dit is er één. */


/* ---------- de rivier, met de wiskunde van /pages/kaart ---------- */
const NS='http://www.w3.org/2000/svg';
const mk=(n,a,c)=>{const e=document.createElementNS(NS,n);for(const k in a)e.setAttribute(k,a[k]);if(c)e.setAttribute('class',c);return e;};
const stroomdelen=[], knoopEls=[];
let ezelOp=null;
(function tekenRivier(){
  const N=HALTES.length, W=900, H=2300, X=450, Y_BRON=80, Y_MOND=H-80;
  const svg=mk('svg',{viewBox:`0 0 ${W} ${H}`,'aria-hidden':'true'});
  /* DE BEDDING. Hieronder groeien de waas en de stroom mee met de scroll, maar die
     begonnen alle drie op lengte NUL — dus op scrollpositie nul stond er een leeg
     crème scherm met alleen een kop erop. Je kunt niets zien gloeien langs een lijn
     die er nog niet is. Deze laag is de hele rivier, meteen zichtbaar en zonder
     dashoffset: een ingesneden lijn waar het goud daarna langs trekt. Zo zie je
     vanaf het eerste beeld de vorm van zevenduizend jaar, en dan duik je erin. */
  const gBed=mk('g'), gWaas=mk('g'), gStroom=mk('g'), gKnopen=mk('g');
  svg.append(gBed,gWaas,gStroom,gKnopen);
  const stap=(Y_MOND-Y_BRON-300)/(N-1), Y1=Y_BRON+210;
  const knik=i=>(i%2===0?-1:1)*22*(1-i/(N+1));
  const kruis=Array.from({length:N},(_,i)=>({x:X+knik(i),y:Y1+i*stap}));
  const loop=[{x:X,y:Y_BRON},...kruis,{x:X,y:Y_MOND}];
  const bocht=(p0,p1,p2,p3)=>
    `M${p1.x.toFixed(1)} ${p1.y.toFixed(1)} C`+
    `${(p1.x+(p2.x-p0.x)/6).toFixed(1)} ${(p1.y+(p2.y-p0.y)/6).toFixed(1)},`+
    `${(p2.x-(p3.x-p1.x)/6).toFixed(1)} ${(p2.y-(p3.y-p1.y)/6).toFixed(1)},`+
    `${p2.x.toFixed(1)} ${p2.y.toFixed(1)}`;
  const n=loop.length-1;
  for(let i=0;i<n;i++){
    const p0=loop[Math.max(0,i-1)],p1=loop[i],p2=loop[i+1],p3=loop[Math.min(loop.length-1,i+2)];
    const d=bocht(p0,p1,p2,p3), groei=i/(n-1), dik=1.4+groei*9;
    /* de gloed: drie brede doorschijnende strepen ónder de stroom, met dezelfde
       dashoffset — anders loopt de gloed vooruit op het water */
    const waasjes=[[16,.05],[9,.08],[4,.12]].map(([reik,dek])=>{
      const w=mk('path',{d},'stroomwaas');
      w.style.strokeWidth=(dik+reik).toFixed(2); w.style.strokeOpacity=dek;
      gWaas.appendChild(w); return w;
    });
    const bed=mk('path',{d},'stroombed');
    /* niet dunner dan dit: bij de bron is de stroom 1,4 breed en op 0,55 daarvan
       werd de bedding een haarlijn die je niet zag */
    bed.style.strokeWidth=Math.max(3.2,dik*0.62).toFixed(2);
    gBed.appendChild(bed);
    const s=mk('path',{d},'stroomdeel');
    s.style.strokeWidth=dik.toFixed(2);
    s.style.strokeOpacity=(0.55+groei*0.45).toFixed(2);
    gStroom.appendChild(s);
    stroomdelen.push({paden:[s,...waasjes], len:0});
  }
  /* lengtes pas meten als het in de DOM staat */
  requestAnimationFrame(()=>stroomdelen.forEach(sd=>{
    sd.len=sd.paden[0].getTotalLength();
    sd.paden.forEach(p=>{p.style.strokeDasharray=sd.len;p.style.strokeDashoffset=sd.len;});
  }));
  kruis.forEach((k,i)=>{
    const g=mk('g',{transform:`translate(${k.x} ${k.y})`},'knoop');
    g.appendChild(mk('circle',{r:6,cx:0,cy:0},'knoopring'));
    const zij=i%2===0?-1:1, dx=zij*26;
    const t1=mk('text',{x:dx,y:-4,'text-anchor':zij<0?'end':'start'},'knoopjaar'); t1.textContent=HALTES[i].jaar;
    const t2=mk('text',{x:dx,y:15,'text-anchor':zij<0?'end':'start'},'knooplabel'); t2.textContent=HALTES[i].kort;
    g.append(t1,t2); gKnopen.appendChild(g); knoopEls.push(g);
  });
  /* HET EZELTJE OP HET PAD.
     Hij staat bij de bron en loopt met de punt van de lijn mee naar beneden. Dat
     doet twee dingen tegelijk: de opening is niet meer een leeg veld met een lijn,
     en je ziet meteen waar dit over gaat. Zelf getekend, want het thema had geen
     ezelvorm. De kenmerken die er hier toe doen zijn de lange oren, het grote
     hoofd, de rechte rug en de staart met alleen een kwast aan het eind — dat is
     wat een ezel van een paard onderscheidt op silhouet.
     Benen, hals en staart zijn lijnen met ronde uiteinden; dat is veel vergevender
     dan gevulde vormen en leest op klein formaat beter. */
  const ezelEl=mk('g',{},'ezelicoon');
  ezelEl.append(
    mk('path',{d:'M40 58 L38 85 M52 60 L52 87 M70 58 L72 84 M80 56 L82 82'},'ezelbeen'),
    mk('path',{d:'M34 40 C25 46 25 57 30 63'},'ezelstaart'),
    mk('circle',{cx:31,cy:65,r:3.6}),
    mk('ellipse',{cx:60,cy:46,rx:26,ry:15}),
    mk('path',{d:'M80 40 L92 21'},'ezelhals'),
    mk('ellipse',{cx:95.5,cy:17,rx:10.5,ry:7,transform:'rotate(-30 95.5 17)'}),
    mk('ellipse',{cx:89,cy:5,rx:2.7,ry:8.5,transform:'rotate(-14 89 5)'}),
    mk('ellipse',{cx:97.5,cy:4.5,rx:2.7,ry:8.5,transform:'rotate(7 97.5 4.5)'})
  );
  svg.appendChild(ezelEl);
  ezelOp=ezelEl;
  document.getElementById('vluchtKaartvlak').appendChild(svg);
})();

/* ---------- haltes ----------
   Acht plekken die om en om links en rechts staan en in hoogte verspringen.
   Bewust geen vast patroon van precies afwisselen: dan hoor je het ritme en
   wordt het mechanisch. De laatste halte — het kruis — staat als enige in het
   midden en breder; dat is de aankomst en die hoort niet opzij. */
const PLEKKEN=[
  {kant:'links',  top:'58vh'},
  {kant:'rechts', top:'16vh'},
  {kant:'links',  top:'20vh'},
  {kant:'rechts', top:'56vh'},
  {kant:'links',  top:'40vh'},
  {kant:'rechts', top:'22vh'},
  {kant:'links',  top:'60vh'},
  {kant:'rechts', top:'38vh'},
];
const halteEls=HALTES.map((h,i)=>{
  const d=document.createElement('div'); d.className='halte';
  d.innerHTML='<em>'+h.titel+'</em><b>'+h.jaar+'</b><p>'+h.tekst+'</p>';
  /* De laatste drie zijn de aankomst — Zevenduizend jaar, en daarna het verhaal van
     DonQ. Daar houdt het zwenken van links naar rechts op en komt alles in het
     midden te staan. Het speelse hoort bij de reis, niet bij het aankomen. */
  if(i>=HALTES.length-3){
    /* sinds 1-10-2026 rechtsboven in de lucht: in het midden vielen ze over de knuffel
       van het slotbeeld (meisje en ezel staan midden in beeld) */
    d.style.right='6vw'; d.style.top='12vh';
  }else if(i===HALTES.length-4){
    /* de aankomst (halte 8): linksboven, want rechts loopt de vrouw met de bruine ezel naar huis */
    d.style.left='6vw'; d.style.top='14vh';
  }else{
    const p=PLEKKEN[i%PLEKKEN.length];
    if(p.kant==='links') d.style.left='6vw'; else d.style.right='6vw';
    d.style.top=p.top;
  }
  document.getElementById('vluchtHaltes').appendChild(d); return d;
});

/* ---------- film ---------- */
const filmvak=document.getElementById('vluchtFilm'), doek=document.getElementById('vluchtDoek');
const ctx=doek.getContext('2d',{alpha:false});
/* de beelden staan kleiner in het geheugen dan het scherm, dus het opschalen
   bepaalt hoe scherp het eruitziet; dit kost niets en scheelt zichtbaar */
ctx.imageSmoothingEnabled=true; ctx.imageSmoothingQuality=/[?&]vluchtglad=laag/.test(location.search)?'low':'high';   /* ?vluchtglad=laag: meten wat de gladde opschaling kost */
const kaartvlak=document.getElementById('vluchtKaartvlak'), kaartkop=document.getElementById('vluchtKop');
const kaartlaag=document.getElementById('vluchtKaartlaag');
const hud=document.getElementById('vluchtHud'), jaarEl=document.getElementById('vluchtJaar');

/* DE ZIJRAIL. Op de geschiedenis loopt naast de tekst een smalle rivier mee die
   laat zien waar je bent. Hier ontbrak die: zodra de kaart kantelde en de film
   het overnam, was er niets meer dat zei hoe ver je was en hoeveel er nog kwam.
   Dit is dezelfde vorm in het klein: een verticale lijn met de haltes als
   stippen, het ezeltje dat meeloopt, en het jaartal ernaast. Hij bestaat alleen
   in de breedte waar er een kolom voor over is; zie de CSS. */
const rail=document.getElementById('vluchtRail');
let railStippen=[], railEzel=null, railVul=null, railJaar=null;
if(rail){
  const NS='http://www.w3.org/2000/svg';
  const mkr=(t,a)=>{const e=document.createElementNS(NS,t);for(const k in a)e.setAttribute(k,a[k]);return e;};
  const RH=380;
  const svg=mkr('svg',{viewBox:`0 0 104 ${RH+40}`,class:'vlucht__railsvg','aria-hidden':'true'});
  svg.appendChild(mkr('line',{x1:20,y1:20,x2:20,y2:RH+20,class:'railspoor'}));
  railVul=mkr('line',{x1:20,y1:20,x2:20,y2:20,class:'railvul'}); svg.appendChild(railVul);
  HALTES.forEach((h,i)=>{
    const y=20+h.p*RH;
    const g=mkr('g',{class:'railstip',transform:`translate(20 ${y.toFixed(1)})`});
    g.appendChild(mkr('circle',{r:3.2}));
    const t=mkr('text',{x:12,y:4}); t.textContent=h.jaar; g.appendChild(t);
    svg.appendChild(g); railStippen.push(g);
  });
  railEzel=mkr('g',{class:'ezelicoon railezel'});
  railEzel.innerHTML='<path class="ezelbeen" d="M40 58 L38 85 M52 60 L52 87 M70 58 L72 84 M80 56 L82 82"/>'+
    '<path class="ezelstaart" d="M34 40 C25 46 25 57 30 63"/><circle cx="31" cy="65" r="3.6"/>'+
    '<ellipse cx="60" cy="46" rx="26" ry="15"/><path class="ezelhals" d="M80 40 L92 21"/>'+
    '<ellipse cx="95.5" cy="17" rx="10.5" ry="7" transform="rotate(-30 95.5 17)"/>'+
    '<ellipse cx="89" cy="5" rx="2.7" ry="8.5" transform="rotate(-14 89 5)"/>'+
    '<ellipse cx="97.5" cy="4.5" rx="2.7" ry="8.5" transform="rotate(7 97.5 4.5)"/>';
  svg.appendChild(railEzel);
  rail.appendChild(svg);
  railJaar=rail.querySelector('[data-railjaar]');
  rail.dataset.railh=RH;
}
/* tekst en stijl alleen schrijven als ze veranderen: elke textContent-toewijzing is
   een layout, ook met dezelfde tekst, en dat telt op een telefoon per beeld mee */
const zetTekst=(el,t)=>{ if(el && el.__t!==t){ el.__t=t; el.textContent=t; } };
const zetStijl=(el,k,v)=>{ if(el && el.style[k]!==v) el.style[k]=v; };
function tekenRail(p, jaartekst){
  if(!rail) return;
  const RH=Number(rail.dataset.railh)||380, y=20+p*RH;
  railVul.setAttribute('y2', y.toFixed(1));
  railEzel.setAttribute('transform', `translate(20 ${y.toFixed(1)}) scale(0.22) translate(-60 -88)`);
  railStippen.forEach((g,i)=>g.classList.toggle('is-aan', p>=HALTES[i].p-0.005));
  if(jaartekst!=null) zetTekst(railJaar,jaartekst);
  zetStijl(rail,'opacity',(p>0.01 && p<0.995) ? (1-uitrol).toFixed(3) : '0');
}
const tijdvakEl=document.getElementById('vluchtTijdvak'), balk=document.getElementById('vluchtBalk');
const wenk=document.getElementById('vluchtWenk'), ladenEl=document.getElementById('vluchtLaden');
const rustig=matchMedia('(prefers-reduced-motion: reduce)').matches;
/* Zolang de vlucht écht draait hoeft de platte kaart eronder niet te staan: je hebt
   hem net gevlogen. Zonder JS of bij rustige beweging komt deze klasse er nooit op
   en blijft de kaart gewoon staan als terugval. */
if(!rustig) document.documentElement.classList.add('vlucht-aan');

/* Op een telefoon is van het beeld van 1280 breed maar een strook van ~330 zichtbaar
   (cover op een staand scherm); op DPR 2 wordt die 2,4× opgeblazen, op 1,5 1,8×. Dat
   ziet er hetzelfde uit, het vult half zoveel pixels per beeld. */
/* HET DOEK NIET GROTER DAN DE FILM VERDIENT. De clips zijn 716 pixels hoog. Op een
   retina-laptop (dpr 2, venster 900 hoog) was het doek 2880×1800: vier keer zoveel
   pixels tekenen als op dpr 1, terwijl er boven 1,5× de bronhoogte geen detail meer
   bij komt. Dus op een breed scherm ten hoogste 1,5 × 716 / vensterhoogte (bij 900
   hoog: 1,19), op de telefoon blijft 1,5 (daar is de uitsnede al klein). ?vluchtdpr=2
   dwingt de oude maat af, om te meten. Armyan (17-09-2026): "op andere apparaten
   niet altijd soepel". */
/* VIJF LAGEN, VIER LIGGEND EN STAAND (25-09-2026, tweede ronde; Armyan: "fix de kwaliteit
   van de kaart videos. ik weet dat je goede kwaliteit heb").
   Gemeten tegen de 24 Mbit/s-film die hij goed vond (PSNR tegen de Kling-bron, beeld voor
   beeld): die haalt 40 tot 41,5 dB per clip; de grote laag van de eerste ronde 37,6. Met
   twee passes op de hardware-encoder haalt H.264 met een sleutelbeeld om de 12 beelden
   hetzelfde op 22 tot 25 Mbit/s (per clip de laagste bitrate die het doel haalt):
     liggend  groot        vlucht-N-g.mp4   1920x1080  de kwaliteit van de film
              gewoon       vlucht-N.mp4     1280x720   terugval
              klein        vlucht-N-k.mp4    960x540   trage toestellen
     staand   staand       vlucht-N-s.mp4    720x1080  telefoon: het middelste deel op volle
                                                       hoogte, zelfde scherpte als groot met
                                                       38% van de pixels
              staandKlein  vlucht-N-sk.mp4   480x720   trage telefoons
   Op een staand scherm is van een liggende film met cover alleen het midden te zien (op
   390x844 zo'n 500 van de 1920 pixels); de staande laag IS dat midden.
   Wat het wazige beeld veroorzaakte: op een M2 met een 2560 pixels brede monitor stapte de
   meting (grens 110 ms per groep, gemiddeld over drie groepen) bij een druk systeem terug
   naar 960 pixels, 2,7 keer opgerekt. Nu is de hoogste laag de regel en stapt hij alleen
   terug op een meting die dat echt rechtvaardigt (zie wisselLaag). */
/* 26-09-2026 (Armyan: "allebei, en D voor de karavaan"): tussenbeelden en de datastroom van het origineel.
   Uit de Kling-originelen zijn meesters op 48 fps gemaakt (Apple's VTFrameRateConversion: elk origineel
   beeld blijft, ertussen één berekend beeld; niet over de harde snede groeve/karavaan), met correctie D op
   de karavaan. Twee lagen op 48 fps (groot, staand) voor soepel scrollen, en dezelfde maat op 24 fps
   (groot24, staand24) als eerste stap terug, zodat een druk maar snel toestel eerst beelden per seconde
   inlevert en niet meteen scherpte. groot24 = 35 Mbit/s, het niveau van het origineel; groot heeft per beeld
   dezelfde kwaliteit (PSNR tegen de meester). */
const HOOG=(D.hoog&&typeof D.hoog==='object')?D.hoog:{ultra:1440,groot:1080,groot24:1080,grootLicht:1080,gewoon:720,klein:540,staandUltra:2160,staand:1080,staand24:1080,staandKlein:720};
const BREED={ultra:2560,groot:1920,groot24:1920,grootLicht:1920,gewoon:1280,klein:960,staandUltra:1080,staand:720,staand24:720,staandKlein:480};
const FPSL=l=>(l==='ultra'||l==='groot'||l==='staand')?48:24;
/* decodeerwerk per seconde film: pixels x beelden. grootLicht kost evenveel als groot24 (alleen minder data) */
const KOST=l=>(BREED[l]||1280)*(HOOG[l]||720)*FPSL(l);
/* de hoogste datastroom per laag over de zes clips (Mbit/s), uit de sectie; voor de lijnkeuze */
const MBIT=(D.mbit&&typeof D.mbit==='object')?D.mbit:{};
/* 48 fps-laag naar zijn 24 fps-tegenhanger: voor het videopad (geen WebCodecs), dat 48 fps niet aankan */
function naar24(){ const t={ultra:'groot24',groot:'groot24',staandUltra:'staand24',staand:'staand24'}[laag]; if(t&&HEEFT(t)){ laag=t; zetBronnen(); } }
const WEBKIT=/^Apple/.test(navigator.vendor||'')||/iPhone|iPad|iPod/.test(navigator.userAgent);
CLIPS.forEach(c=>{ c.gewoon=c.src; });
const HEEFT=l=>CLIPS.every(c=>c[l]);
/* 720/1080: tot deze verhouding vult de staande laag het scherm zonder in de breedte op te rekken */
const STAAND_MAX=0.667;
/* er is een staande vorm zodra een van de staande lagen er is (sinds 1-10-2026 alleen staand24/staandKlein) */
const STAANDE=()=>HEEFT('staandUltra')||HEEFT('staand')||HEEFT('staand24')||HEEFT('staandKlein');
const vormNu=()=>(innerWidth/Math.max(1,innerHeight)<=STAAND_MAX&&STAANDE())?'staand':'liggend';
/* grootLicht = 1080p op 24 fps met ~23 Mbit/s: voor lijnen van 30 tot 45 Mbit/s, die groot24 (35) niet halen
   maar 1080p verdienen (review 26-09: "lijnen van 30 tot 43 Mbit/s verliezen 1080p") */
/* TELEFOON STAAND: 24 ECHTE BEELDEN, GEEN TUSSENBEELDEN (28-09-2026). De staande 48 fps-laag had om het
   andere beeld een berekend tussenbeeld, en op een telefoon wordt de 720 x 1080-uitsnede 2,3 keer opgerekt:
   daar zie je elk zacht beeld (Armyan: "de kwaliteit op telefoon is wel erg shit"). Naast elkaar gemeten op
   hetzelfde moment was staand24 duidelijk scherper. De 48 fps-bestanden (-s) blijven staan maar worden niet
   meer gekozen, behalve met ?vluchtlaag=staand. */
/* 03-10-2026 (Armyan: "kwaliteit op laptop en telefoon kanker slecht"): de film is opnieuw gemaakt uit 4K-versies
   (ByteDance-opschaling van dezelfde Kling-clips, daarna 48 fps-tussenbeelden en correctie D). Dat levert veel meer
   detail op (stenen, vacht, tuig) dan de oude 1080p-bron. Liggend blijft groot (1920x1080 op 48 fps) de hoofdlaag.
   Een 1440p-laag op 48 fps (ultra, vf-N-u.mp4, ?vluchtlaag=ultra) is gemeten en afgevallen: op deze Mac kostte hij
   4,3 ms tekenen per beeld tegen 2,4 en gaf hij bij 11% van de beelden een te lange frame (oud: 1%), voor een
   klein beetje extra scherpte. Staand is staandUltra (1080x2160 op 24 fps, vf-N-su.mp4) de nieuwe bovenlaag:
   de telefoon heeft 2556 pixels hoogte, de oude 1080 werd 2,4 keer opgerekt. */
const TREDEN={liggend:['groot','groot24','grootLicht','gewoon','klein'],staand:['staandUltra','staand24','staandKlein']};
/* een toestel dat zelf om minder vraagt (weinig geheugen of kernen) begint hier: liggend 1280, staand de lichtste
   (zoals vóór 26-09; staand24 was voor een 4 GB-Android 5,5 keer zoveel tekenwerk) */
const MATIG={liggend:'gewoon',staand:'staandKlein'};
const vluchtParam=n=>new RegExp('[?&]'+n+'(?:=(\\w+))?').exec(location.search);
/* hoeveel treden lager het toestel of de verbinding zelf vraagt (0, 1 of 2) */
function zwakte(){
  try{
    const c=navigator.connection;
    if(c&&(c.saveData||/(^|[^4-9])[23]g$/.test(c.effectiveType||''))) return 2;
    let t=0;
    /* Apple meldt geen geheugen, en elk Apple-toestel decodeert 1080p in hardware */
    if(!WEBKIT){
      const g=navigator.deviceMemory, k=navigator.hardwareConcurrency;
      if((typeof g==='number'&&g<=2)||(typeof k==='number'&&k<=2)) return 2;
      if((typeof g==='number'&&g<=4)||(typeof k==='number'&&k<=4)) t=1;
    }
    /* Bewust NIET navigator.connection.downlink: dat is een schatting van Chrome (tot 10
       Mbit/s afgekapt, zonder metingen ~1,5 tot 2,7) en duwde snelle desktops naar een
       lagere laag (review 25-09). De echte lijn meet de motor zelf (stat.doorvoer). */
    return t;
  }catch(e){ return 0; }
}
function beginLaag(v){
  const t=TREDEN[v].filter(HEEFT); if(!t.length) return 'gewoon';
  /* meetknop: ?vluchtlaag=groot|gewoon|klein|staand|staandKlein; ?vluchtklein = de lichtste */
  const p=vluchtParam('vluchtlaag'); if(p&&p[1]&&HEEFT(p[1])) return p[1];
  if(vluchtParam('vluchtklein')) return t[t.length-1];
  const z=zwakte(), mi=t.indexOf(MATIG[v]); let i=z>=2?t.length-1:z===1?(mi>=0?mi:Math.min(t.length-1,1)):0;
  /* een telefoon dwars heeft aan 1920 pixels niets extra's */
  if(v==='liggend'&&i===0&&innerWidth<900&&t.indexOf('gewoon')>0) i=t.indexOf('gewoon');
  /* eerder in dit tabblad teruggestapt (alleen op een echte meting, zie wisselLaag) */
  try{ const o=sessionStorage.getItem('donq-vlucht-trede-'+v); const j=o?t.indexOf(o):-1; if(j>i) i=j; }catch(e){}
  return t[i];
}
let vorm=vormNu(), laag=beginLaag(vorm);
function zetBronnen(){ CLIPS.forEach(c=>{ c.src=c[laag]||c.gewoon; c.posterNu=(vorm==='staand'&&c.posterStaand)||c.poster; }); }
zetBronnen();
/* DOEKDICHTHEID. Breed scherm: tot 1,5 x de bronhoogte (meer detail zit er niet in). Staande
   laag op de telefoon: tot 2 x de bronhoogte, praktisch de volle schermdichtheid. Op een vaste 1,5
   rekte de telefoon het doek daarna nog eens anderhalf tot twee keer op, en was het beeld dubbel
   zacht (Armyan 25-09: "ik vind kwaliteit slecht"). De lichte lagen blijven op 1. */
const doekDPR=l=>(l==='klein'||l==='staandKlein')?1
  :(l==='staandUltra'||l==='staand'||l==='staand24')?Math.min(devicePixelRatio||1,Math.max(1.5,2*(HOOG[l]||1080)/innerHeight))
  :Math.min(devicePixelRatio||1,innerWidth<900?1.5:Math.max(1,1.5*(HOOG[l]||720)/innerHeight));
const dprParam=+((/[?&]vluchtdpr=([\d.]+)/.exec(location.search)||[])[1]||0);
let W=0,H=0,DPR=dprParam||doekDPR(laag),vakW=0,vakH=0;
function maat(){
  W=innerWidth;H=innerHeight;
  /* DE KOP STOND ACHTER DE SITE-HEADER. Hij zat op top:4vh — 32px bij een venster
     van 800 — terwijl de aankondigingsbalk en de navigatie samen tot 121px komen.
     "Zevenduizend jaar" was dus onzichtbaar, en dat is precies waarom de opening
     leeg aanvoelde. Het thema heeft geen token voor die hoogte en .head krimpt zelfs
     bij het scrollen, dus meten we hem en zetten we er een variabele voor. */
  const head=document.querySelector('.head');
  const hoog=head?Math.round(head.getBoundingClientRect().height):110;
  sectie.style.setProperty('--kopvrij',(hoog+20)+'px');
}
addEventListener('resize',maat);maat();
function doekMaat(w,h){
  if(vakW===w&&vakH===h)return; vakW=w;vakH=h;
  doek.width=Math.round(w*DPR);doek.height=Math.round(h*DPR);
  ctx.setTransform(DPR,0,0,DPR,0,0);
}
/* op een ultrabreed scherm (breder dan 2,05:1) valt er boven en onder veel weg. In de laatste twee clips
   (de overgang naar huis en het slot, waar de ezel hoog in beeld staat) zakt de uitsnede geleidelijk van 50%
   naar 30%, zodat de oren blijven staan en er geen sprong in zit; eerder staan de ezels laag en blijft het 50% */
let ankerClip=-1, ankerT=0;
const ankerAy=()=>{
  if(vakW/vakH<=2.05) return 0.5;
  const n=CLIPS.length;
  if(ankerClip<n-2) return 0.5;
  return ankerClip===n-2?0.5-0.1*ankerT:0.4-0.1*ankerT;
};
const cover=(b,bw,bh)=>{const s=Math.max(vakW/bw,vakH/bh),w=bw*s,h=bh*s,ay=ankerAy();
  ctx.drawImage(b,(vakW-w)/2,(vakH-h)*ay,w,h);};

/* DE KLEINE CLIPS (vlucht-N-k.mp4, 960x536, 2,1 MB) VOOR LANGZAMERE TOESTELLEN.
   Armyan (17-09-2026): "op laptop en iPhone draait de film soepel, op andere
   apparaten niet altijd". Gemeten met een viermaal afgeknepen processor: 303 ms per
   keyframegroep en 29 beeldwissels per seconde, tegen 51 ms en 59 wissels zonder
   knijpen. De grote clips blijven de standaard; de kleine (56% van de pixels) komen
   erbij als het toestel er zelf om vraagt: zuinig dataverkeer, weinig geheugen of
   kernen, een eerdere keuze in deze sessie, of ?vluchtklein. En als de eerste
   groepen bij het laden traag decoderen (zie wisselKlein) schakelt hij vanzelf om,
   vóórdat de film in beeld is. */
/* de laagkeuze staat hierboven, bij de doekmaat */
const totaalSec=CLIPS.reduce((a,c)=>a+c.sec,0);
let acc=0; for(const c of CLIPS){c.van=acc/totaalSec;acc+=c.sec;c.tot=acc/totaalSec;}
/* de laadmelding hoort weg zodra het eerste beeld getekend is */
let ladenWeg=false;
const ladenUit=()=>{ if(!ladenWeg){ ladenWeg=true; ladenEl.classList.add('is-uit'); } };

/* ====================================================================
   DE BEELDEN — twee motoren, de werkende wint.

   Wat het probleem was, gemeten op de echte pagina (audit-2026-09-14/
   kaart-beelden/reeks/meet.mjs, headless Chrome, 1440×900): de film volgde
   de scroll met een <video>-element dat vooruit SPEELDE (snelheid naar rato
   van het gat) en achteruit SEEKTE. Dat gaf een achterstand van 10 tot 18
   beelden tijdens het scrollen, 8 tot 14 beeldwissels per seconde bij een
   veeg over het trackpad, 2 tot 4 per seconde bij terugvegen, en haperingen
   tot 650 ms. Dat is het "lagt heel veel" van de eigenaar, en het zit in de
   aard van het pad: een videodecoder is gemaakt om vooruit te spelen, niet om
   op een willekeurig beeld te staan.

   MOTOR 1 — WebCodecs. De clip wordt als bestand opgehaald, hier uitgelezen
   (het is ons eigen mp4, dus een lezer van tachtig regels volstaat: stts,
   ctts, stss, stsc, stsz, stco, avcC) en met VideoDecoder per keyframegroep
   gedecodeerd — hardwarematig waar het kan. De gedecodeerde beelden staan
   als ruwe pixels (NV12, 1,4 MB per beeld) in een venster rond het gewenste
   beeld: de groep waar je bent, twee vooruit in de scrollrichting, één
   terug. Tekenen is dan een opzoeking: geen seek, geen wachten, achteruit
   even goedkoop als vooruit. Wat er niet is, wordt niet zwart: we tekenen het
   dichtstbijzijnde beeld dat er wél is, en tot de clip binnen is de poster.

   MOTOR 2 — het <video>-pad van hiervoor, ongewijzigd, voor browsers zonder
   VideoDecoder of als het decoderen onderweg stukloopt.
   ==================================================================== */

/* ---- een mp4 lezen (alleen wat VideoDecoder nodig heeft) ----
   Bewust smal: de edit list (elst, in onze clips leeg) wordt niet gelezen, geen
   meerdere sporen, geen fragmented mp4.
   De clips komen uit herkodeer.swift (audit-2026-09-14/kaart-beelden/clips): H.264
   zonder B-frames, keyframe om de 12 beelden, moov vooraan, niet getrimd. Een clip
   die met een ander gereedschap is geknipt of met herordening is gecodeerd hoort
   hier niet in: met B-frames liet de decoder per groep één beeld vallen. */
function leesMp4(buf,tot){
  tot=tot||buf.byteLength;
  const dv=new DataView(buf), u8=new Uint8Array(buf);
  const str=o=>String.fromCharCode(u8[o],u8[o+1],u8[o+2],u8[o+3]);
  const kinderen=(van,tot)=>{const r=[];let o=van;while(o+8<=tot){let n=dv.getUint32(o),t=str(o+4),h=8;
    if(n===1){if(o+16>tot)break;n=Number(dv.getBigUint64(o+8));h=16;}else if(n===0)n=tot-o; if(n<h)break; r.push({t,o,n,h}); o+=n;} return r;};
  const vind=(l,t)=>l.find(b=>b.t===t);
  /* de clips zijn met de moov vooraan geschreven; zolang die nog niet helemaal binnen
     is geven we null terug en probeert de lader het bij de volgende hap opnieuw */
  const moov=vind(kinderen(0,tot),'moov'); if(!moov) return null;
  if(moov.o+moov.n>tot) return null;
  for(const trak of kinderen(moov.o+moov.h,moov.o+moov.n).filter(b=>b.t==='trak')){
    const mdia=vind(kinderen(trak.o+8,trak.o+trak.n),'mdia'); if(!mdia) continue;
    const mk=kinderen(mdia.o+8,mdia.o+mdia.n);
    const hdlr=vind(mk,'hdlr'); if(!hdlr||str(hdlr.o+16)!=='vide') continue;
    const mdhd=vind(mk,'mdhd'); const tijdschaal=u8[mdhd.o+8]===1?dv.getUint32(mdhd.o+28):dv.getUint32(mdhd.o+20);
    const minf=vind(mk,'minf'), stbl=vind(kinderen(minf.o+8,minf.o+minf.n),'stbl');
    const sk=kinderen(stbl.o+8,stbl.o+stbl.n), tabel=t=>vind(sk,t);
    const stsd=tabel('stsd'), entry=kinderen(stsd.o+16,stsd.o+stsd.n)[0];
    if(!/avc1|avc3/.test(entry.t)) throw new Error('geen avc1');
    const breed=dv.getUint16(entry.o+32), hoog=dv.getUint16(entry.o+34);
    const avcC=vind(kinderen(entry.o+86,entry.o+entry.n),'avcC'); if(!avcC) throw new Error('geen avcC');
    const beschrijving=u8.slice(avcC.o+8,avcC.o+avcC.n);
    const codec='avc1.'+[1,2,3].map(i=>beschrijving[i].toString(16).padStart(2,'0')).join('');
    const stts=tabel('stts'), duren=[]; {const n=dv.getUint32(stts.o+12);let o=stts.o+16;
      for(let i=0;i<n;i++,o+=8){const c=dv.getUint32(o),d=dv.getUint32(o+4);for(let j=0;j<c;j++)duren.push(d);}}
    const N=duren.length;
    const ctts=tabel('ctts'), cto=new Array(N).fill(0); if(ctts){const ver=u8[ctts.o+8],n=dv.getUint32(ctts.o+12);let o=ctts.o+16,k=0;
      for(let i=0;i<n;i++,o+=8){const c=dv.getUint32(o),d=ver===1?dv.getInt32(o+4):dv.getUint32(o+4);for(let j=0;j<c&&k<N;j++)cto[k++]=d;}}
    const stss=tabel('stss'), key=new Uint8Array(N); if(stss){const n=dv.getUint32(stss.o+12);for(let i=0;i<n;i++)key[dv.getUint32(stss.o+16+i*4)-1]=1;} else key.fill(1);
    const stsz=tabel('stsz'), vast=dv.getUint32(stsz.o+12), groottes=new Array(N);
    if(vast) groottes.fill(vast); else for(let i=0;i<N;i++) groottes[i]=dv.getUint32(stsz.o+20+i*4);
    const stsc=tabel('stsc'), runs=[]; {const n=dv.getUint32(stsc.o+12);for(let i=0;i<n;i++){const o=stsc.o+16+i*12;runs.push({eerste:dv.getUint32(o),per:dv.getUint32(o+4)});}}
    const stco=tabel('stco'), co64=tabel('co64'), chunks=[];
    if(co64){const n=dv.getUint32(co64.o+12);for(let i=0;i<n;i++)chunks.push(Number(dv.getBigUint64(co64.o+16+i*8)));}
    else {const n=dv.getUint32(stco.o+12);for(let i=0;i<n;i++)chunks.push(dv.getUint32(stco.o+16+i*4));}
    const offsets=new Array(N); {let s=0;for(let c=0;c<chunks.length&&s<N;c++){let per=1;for(const r of runs)if(c+1>=r.eerste)per=r.per;
      let o=chunks[c];for(let j=0;j<per&&s<N;j++){offsets[s]=o;o+=groottes[s];s++;}}}
    /* pts in microseconden; de decoder geeft die ongewijzigd terug op het beeld */
    const pts=new Array(N), dur=new Array(N); {let t=0;for(let i=0;i<N;i++){pts[i]=Math.round((t+cto[i])*1e6/tijdschaal);dur[i]=Math.round(duren[i]*1e6/tijdschaal);t+=duren[i];}}
    const volgorde=[...Array(N).keys()].sort((a,b)=>pts[a]-pts[b]);
    const beeldNr=new Array(N); volgorde.forEach((s,i)=>beeldNr[s]=i);
    /* beeldnummer bij een teruggegeven tijdstempel: de dichtstbijzijnde pts (binair
       gezocht), niet een exacte microseconde — een decoder mag afronden */
    const ptsOp=volgorde.map(s=>pts[s]);
    const nrVanPts=t=>{ let lo=0,hi=N-1; while(lo<hi){const mid=(lo+hi)>>1; if(ptsOp[mid]<t) lo=mid+1; else hi=mid;}
      if(lo>0 && Math.abs(ptsOp[lo-1]-t)<Math.abs(ptsOp[lo]-t)) lo--; return lo; };
    /* keyframegroepen in decodeervolgorde, met het bereik aan beeldnummers dat ze opleveren */
    const gops=[]; for(let i=0;i<N;i++) if(key[i]) gops.push({van:i,tot:N});
    for(let g=0;g+1<gops.length;g++) gops[g].tot=gops[g+1].van;
    gops.forEach(g=>{let lo=Infinity,hi=-1;for(let s=g.van;s<g.tot;s++){lo=Math.min(lo,beeldNr[s]);hi=Math.max(hi,beeldNr[s]);}g.beeldVan=lo;g.beeldTot=hi+1;});
    return {codec,beschrijving,breed,hoog,N,offsets,groottes,pts,dur,key,nrVanPts,gops};
  }
  throw new Error('geen videospoor');
}

/* ---- motor 1: WebCodecs ---- */
function maakDecoderFilm(opties){
  opties=opties||{};
  if(typeof VideoDecoder==='undefined'||typeof EncodedVideoChunk==='undefined'||typeof VideoFrame==='undefined') return null;
  /* Het venster in keyframegroepen: de eigen groep, VOOR vooruit in de scrollrichting,
     ACHTER terug. Bij groepen van 12 beelden is dat 48 beelden × 1,4 MB = 66 MB op een
     groot scherm en 36 beelden op een telefoon. Het venster IS de geheugengrens: alles
     erbuiten gaat weg. Een los plafond bovenop het venster gooide beelden weg die de
     wensenlijst meteen weer liet decoderen — een lus die de decoder volledig bezette. */
  const smal=innerWidth<900;
  /* Op 48 fps beslaat een groep van 12 beelden maar een kwart seconde film: één groep extra vooruit. Op een
     groot scherm met minstens 8 GB (Chrome meldt dat) wordt het venster (1+3+1) x 12 = 60 beelden van 3,1 MB
     (1080p NV12) = ~190 MB; zonder die melding (Safari) blijft het op twee vooruit. Telefoon: 48 beelden. */
  const VEEL=(laag==='ultra'||laag==='groot'||laag==='staand');
  const VOOR=smal?(VEEL?2:1):(VEEL&&navigator.deviceMemory>=8?3:2), ACHTER=1;
  /* de poster is het eerste beeld van de clip als lichte jpg (vlucht-poster-N.jpg) */
  const clips=CLIPS.map((c,i)=>({i,src:c.src,poster:c.posterNu||c.poster||c.src.replace(/vlucht-(\d+)\.mp4.*$/,'vlucht-poster-$1.jpg'),buf:null,mp4:null,laadt:null,mislukt:false,ontvangen:0,totaal:0,pogingen:0,
    heeft:null,cache:new Map(),posterImg:null}));
  let dood=false, gesloten=false, decoder=null, cfgSleutel='', uitvoer=[], bezig=false;
  const afbrekers=[];   /* AbortControllers van lopende fetches; vóór laad(), die meteen draait */
  const stat={gops:0,ms:0,tekort:0,herhaald:0,laatste:'',tekenMs:0,tekenN:0,tijden:[]};   /* voor de meting */

  /* HOE EEN GEDECODEERD BEELD BEWAARD WORDT.
     Groot scherm: de ruwe pixels (NV12/I420 via copyTo, 1,4 MB per beeld), bij het
     tekenen weer even in een VideoFrame gewikkeld. Telefoon: alleen de uitsnede die
     op het scherm past, als ImageBitmap (0,9 MB bij 390×844): drawImage(ImageBitmap)
     is op WebKit de snelle weg, en 36 beelden passen dan in 34 MB. Kan een browser de
     ruwe weg niet (copyTo of de VideoFrame-constructor ontbreekt of weigert), dan
     schakelt hij bij het eerste beeld over op de uitsnede in plaats van naar het
     videopad te vallen. */
  let alsUitsnede=smal, proefGedaan=false, snijDoek=null, snijCtx=null, snijVerh=0;
  /* WEBKIT (Safari, en elke browser op de iPhone) HOUDT HET BEELD ZELF VAST.
     Gemeten in de iPhone-simulator (audit-2026-09-14/kaart-beelden/reeks, 15-09):
     de uitsnede via een OffscreenCanvas kostte daar 482 ms per keyframegroep en gaf
     8 beeldwissels per seconde; het VideoFrame zelf bewaren (clone) en rechtstreeks
     tekenen kostte 128 ms per groep en gaf 31 wissels. WebKit tekent een videobeeld
     langs de GPU, elke omzetting naar bitmap gaat door de CPU. Chromium blijft op de
     ruwe kopie: daar kan een decoder blokkeren zodra je zijn uitvoerbeelden vasthoudt.
     ?vluchtbewaar=ruw|uitsnede|bitmap|frame|niets dwingt een manier af, om op een echt
     toestel te vergelijken (zie donq-vlucht-meet.js). */
  const webkit=/^Apple/.test(navigator.vendor||'')||/iPhone|iPad|iPod/.test(navigator.userAgent);
  const bewaarKeuze=(/[?&]vluchtbewaar=(\w+)/.exec(location.search)||[])[1]||(webkit?'frame':'');
  if(bewaarKeuze==='ruw') alsUitsnede=false; else if(bewaarKeuze==='uitsnede') alsUitsnede=true;
  async function uitsnede(f){
    const bw=f.displayWidth, bh=f.displayHeight, vw=vakW||innerWidth, vh=vakH||innerHeight;
    const sch=Math.max(vw/bw,vh/bh);
    const cw=Math.min(bw,Math.round(vw/sch)), ch=Math.min(bh,Math.round(vh/sch));
    const sx=Math.round((bw-cw)/2), sy=Math.round((bh-ch)/2);
    if(!snijDoek||snijDoek.width!==cw||snijDoek.height!==ch){
      snijDoek=typeof OffscreenCanvas!=='undefined'?new OffscreenCanvas(cw,ch):Object.assign(document.createElement('canvas'),{width:cw,height:ch});
      snijCtx=snijDoek.getContext('2d',{alpha:false});
    }
    snijCtx.drawImage(f,sx,sy,cw,ch,0,0,cw,ch);
    const bitmap=snijDoek.transferToImageBitmap?snijDoek.transferToImageBitmap():await createImageBitmap(snijDoek);
    snijVerh=vw/vh;
    return {bitmap,bw:cw,bh:ch};
  }
  async function bewaar(f){
    if(bewaarKeuze==='niets') return {leeg:true,bw:f.displayWidth,bh:f.displayHeight};
    if(bewaarKeuze==='frame') return {frame:f.clone(),bw:f.displayWidth,bh:f.displayHeight};
    if(bewaarKeuze==='bitmap') return {bitmap:await createImageBitmap(f),bw:f.displayWidth,bh:f.displayHeight};
    if(!alsUitsnede && f.format){
      try{
        /* ruwe pixels bewaren, los van de decoder: die heeft zijn buffers terug en kan
           door. copyTo kopieert het zichtbare deel (716 hoog, niet de gecodeerde 720);
           het nieuwe beeld krijgt dus dát als gecodeerde maat, anders overlappen de vlakken */
        const vr=f.visibleRect, data=new ArrayBuffer(f.allocationSize());
        const layout=await f.copyTo(data);
        const init={format:f.format,codedWidth:vr.width,codedHeight:vr.height,layout,
          visibleRect:{x:0,y:0,width:vr.width,height:vr.height},displayWidth:f.displayWidth,displayHeight:f.displayHeight,timestamp:0};
        if(!proefGedaan){ const t=new VideoFrame(data,init); t.close(); proefGedaan=true; }
        return {data,init,bw:f.displayWidth,bh:f.displayHeight};
      }catch(e){ alsUitsnede=true; console.warn('[vlucht] ruwe beelden gaan hier niet, dan de uitsnede',e); }
    }
    if(alsUitsnede) return uitsnede(f);
    return {bitmap:await createImageBitmap(f),bw:f.displayWidth,bh:f.displayHeight};
  }
  /* draait het scherm (of verandert de verhouding fors), dan klopt de uitsnede niet meer */
  function spoel(){
    for(const c of clips){ if(!c.mp4) continue; for(const it of c.cache.values()){ if(it.bitmap) it.bitmap.close(); if(it.frame) it.frame.close(); } c.cache.clear(); c.heeft.fill(0); c.gopKlaar.fill(0); }
    laatst=null; getekend=null; werk();
  }
  /* alleen als er echt uitsneden in de cache staan; op WebKit staan er hele beelden en
     mag het inklappen van de adresbalk (12% hoogteverschil) nooit alles weggooien */
  const knipt=()=>alsUitsnede&&(bewaarKeuze===''||bewaarKeuze==='uitsnede');
  addEventListener('resize',()=>{ if(knipt()&&snijVerh&&Math.abs(innerWidth/innerHeight-snijVerh)>0.12*snijVerh) spoel(); },{passive:true});
  let wilClip=0, wilNr=0, richting=1;
  let laatst=null;                        /* {clip, nr} van het laatst getekende beeld */

  /* laden: op volgorde, één tegelijk; een clip die nú nodig is gaat voor */
  /* Als stroom, niet als één blok: de clips hebben de moov vooraan, dus na de eerste
     paar honderd kilobyte is de tabel bekend en kan de eerste keyframegroep al
     gedecodeerd worden terwijl de rest nog binnenkomt. c.ontvangen zegt tot waar de
     bytes gelden; een groep is pas te decoderen als hij daaronder valt. */
  function zetKlaar(c,buf,n){ const m=leesMp4(buf,n); if(!m) return false; c.mp4=m; c.buf=buf; c.heeft=new Uint8Array(m.N); c.gopKlaar=new Uint8Array(m.gops.length); return true; }
  function laad(c){
    if(c.laadt||c.mislukt) return c.laadt;
    if(c.buf&&c.totaal&&c.ontvangen>=c.totaal) return null;          /* helemaal binnen */
    /* na de moov hervatten we waar we waren (Range), daarvoor beginnen we opnieuw */
    const hervat=!!(c.buf&&c.mp4&&c.ontvangen>0);
    const afbreker=typeof AbortController!=='undefined'?new AbortController():null; if(afbreker) afbrekers.push(afbreker);
    const headers=hervat?{Range:'bytes='+c.ontvangen+'-'}:{};
    c.laadt=fetch(c.src,{mode:'cors',headers,signal:afbreker?afbreker.signal:undefined}).then(async r=>{
      if(!r.ok) throw new Error('http '+r.status);
      let n=0, buf=c.buf, totaal=c.totaal||0;
      if(hervat&&r.status===206){
        const cr=/\/(\d+)\s*$/.exec(r.headers.get('Content-Range')||'');
        if(!cr||+cr[1]!==totaal) throw new Error('range klopt niet');
        n=c.ontvangen;
      }else{
        totaal=+(r.headers.get('Content-Length')||0);
        if(!r.body||!totaal){
          const b=await r.arrayBuffer(); c.totaal=b.byteLength; c.ontvangen=b.byteLength;
          if(!c.mp4&&!zetKlaar(c,b,b.byteLength)) throw new Error('mp4 niet leesbaar');
          c.buf=b; return;
        }
        if(!buf||buf.byteLength!==totaal){ buf=new ArrayBuffer(totaal); vergeet(c); }
        c.totaal=totaal; c.ontvangen=0;
      }
      const u8=new Uint8Array(buf), lezer=r.body.getReader();
      /* DE LIJN METEN: hoeveel Mbit/s komt er echt binnen, tegen wat deze laag vraagt
         (bytes x 8 / clipduur). Pas na 1,5 s en 1 MB, want de eerste pakketten zeggen niets.
         Een snelle lijn haalt de clip binnen die tijd en wordt dus nooit gemeten: goed zo. */
      const t0=performance.now(), n0=n, sec=(CLIPS[c.i]&&CLIPS[c.i].sec)||5; let gemeten=false;
      for(;;){
        const {done,value}=await lezer.read(); if(done) break;
        if(n+value.length>totaal) throw new Error('meer bytes dan gemeld');
        u8.set(value,n); n+=value.length; c.ontvangen=n;
        if(!gemeten){ const dt=(performance.now()-t0)/1000; if(dt>=1.5&&n-n0>=1048576){ gemeten=true;
          const mbit=(n-n0)*8/dt/1e6; stat.doorvoer=Math.max(stat.doorvoer||0,mbit); stat.metingen=(stat.metingen||0)+1; stat.nodig=totaal*8/sec/1e6; } }
        if(!c.mp4) zetKlaar(c,buf,n);
        if(c.mp4) werk();
      }
      if(n<totaal) throw new Error('afgebroken op '+n+' van '+totaal);
      /* en over de hele clip: de meting na 1,5 s valt op mobiel internet te laag uit (de verbinding
         komt dan nog op gang), en een te lage meting zette een telefoon op de 480 pixels-laag */
      { const dt=(performance.now()-t0)/1000; if(dt>=0.5&&n-n0>=1048576){ const mbit=(n-n0)*8/dt/1e6;
        stat.doorvoer=Math.max(stat.doorvoer||0,mbit); if(!gemeten){ stat.metingen=(stat.metingen||0)+1; stat.nodig=totaal*8/sec/1e6; } } }
      if(!c.mp4&&!zetKlaar(c,buf,n)) throw new Error('mp4 niet leesbaar');
    }).then(()=>{ c.laadt=null; c.pogingen=0; werk(); })
      .catch(e=>{
        c.laadt=null;
        if(c.mislukt) return;                                          /* afgebroken door sluit() */
        /* drie kansen, met een steeds langere adempauze: een netwerkwissel of een
           verbroken verbinding mag niet een zesde van de vlucht voorgoed leeghalen */
        c.pogingen=(c.pogingen||0)+1;
        console.warn('[vlucht] clip laden mislukt ('+c.pogingen+')',c.src,e);
        if(c.pogingen<3){ setTimeout(()=>{ if(!c.mislukt) laad(c); },1500*c.pogingen); return; }
        c.mislukt=true;
        if(!c.mp4){ c.buf=null; if(c.i===0) dood=true; }
      });
    return c.laadt;
  }
  /* alles van een clip weggooien (nieuwe buffer, of opruimen) */
  function vergeet(c){
    for(const it of c.cache.values()){ if(it.bitmap) it.bitmap.close(); if(it.frame) it.frame.close(); }
    c.cache.clear(); c.buf=null; c.mp4=null; c.heeft=null; c.gopKlaar=null;
  }
  /* VOORLADEN. Clip 1 en 2 meteen; 3 tot 6 pas zodra de vlucht echt begonnen is, en
     niet als de bezoeker om zuinig dataverkeer vraagt. Anders haalt elke bezoeker van
     de kaart 27 MB binnen, ook wie nooit voorbij het eerste scherm komt. Een clip die
     nú nodig is (werk) gaat altijd voor; de lus is de achtergrond. */
  let gestart=false, opVerzoek=null;
  (async()=>{
    /* een vervangende film (laagwissel midden in de vlucht) begint bij de clip die nu in
       beeld is, niet bij clip 1 en 2: die zouden de lijn delen met wat je ziet */
    if(opties.vervang){
      await new Promise(r=>{ const kijk=()=>{ if(gestart||dood) r(); else setTimeout(kijk,100); }; kijk(); });
      const volg=[...clips.slice(wilClip),...clips.slice(0,wilClip)];
      for(const c of volg){ if(gesloten) return; try{ await laad(c); }catch(e){ console.warn('[vlucht] voorladen',e); } }
      return;
    }
    for(const c of clips.slice(0,2)){ try{ await laad(c); }catch(e){ console.warn('[vlucht] voorladen',e); } }
    if(navigator.connection&&navigator.connection.saveData) return;
    await new Promise(r=>{ const kijk=()=>{ if(gestart) r(); else setTimeout(kijk,300); }; kijk(); });
    for(const c of clips.slice(2)){ try{ await laad(c); }catch(e){ console.warn('[vlucht] voorladen',e); } }
  })();

  function poster(c){
    if(!c.poster) return null;
    if(!c.posterImg){ const im=new Image(); im.decoding='async'; im.src=c.poster; c.posterImg=im; }
    return (c.posterImg.complete&&c.posterImg.naturalWidth)?c.posterImg:null;
  }
  poster(clips[0]);

  /* Elk beeld wordt verwerkt en gesloten op het moment dat de decoder het afgeeft,
     niet pas na flush(): zo houden we nooit meer dan één of twee van zijn
     uitvoerbeelden vast, en kan een decoder met een kleine uitvoerpool niet
     blokkeren. uitvoer bevat de beloften van die verwerking; de opdracht wacht
     erop na de flush. */
  let uitvoerVoor=null;   /* {c, m} van de groep die nu gedecodeerd wordt */
  function verwerk(f){
    const d=uitvoerVoor;
    if(!d||!d.c.heeft){ f.close(); return Promise.resolve(); }
    const nr=d.m.nrVanPts(f.timestamp);
    if(nr==null||d.c.heeft[nr]){ f.close(); return Promise.resolve(); }
    return bewaar(f).then(item=>{ if(d.c.heeft&&!d.c.heeft[nr]){ d.c.cache.set(nr,item); d.c.heeft[nr]=1; } else { if(item.bitmap) item.bitmap.close(); if(item.frame) item.frame.close(); } })
      .catch(e=>{ console.warn('[vlucht] beeld bewaren mislukt',e); dood=true; })
      .finally(()=>{ try{ f.close(); }catch(e){} });
  }
  function nieuweDecoder(){
    decoder=new VideoDecoder({
      output:f=>{ uitvoer.push(verwerk(f)); },
      error:e=>{ console.warn('[vlucht] decoder',e); dood=true; }
    });
    cfgSleutel='';
  }
  /* alles loslaten als motor 2 het overneemt: decoder, beelden, buffers, lopende fetches */
  function sluit(){
    gesloten=true;   /* bewust dichtgezet (wissel naar de kleine clips): een afgebroken decode is dan geen storing */
    try{ if(decoder&&decoder.state!=='closed') decoder.close(); }catch(e){}
    for(const a of afbrekers){ try{ a.abort(); }catch(e){} }
    for(const c of clips){ c.mislukt=true; vergeet(c); }
  }
  function gopVan(c,nr){ const g=c.mp4.gops; for(let i=0;i<g.length;i++) if(nr<g[i].beeldTot) return i; return g.length-1; }

  /* welke groep nu het meest de moeite is: de eigen, dan vooruit, dan één terug */
  function wensen(){
    const c=clips[wilClip]; if(!c.mp4) return [];
    const g0=gopVan(c,wilNr), lijst=[];
    const stap=(ci,gi,d)=>{ /* een groep verder in richting d, over de clipgrens heen */
      const cc=clips[ci], gg=gi+d;
      if(!cc.mp4) return null;                    /* voorbij een clip die er nog niet is kijken we niet */
      if(gg>=0 && gg<cc.mp4.gops.length) return {ci,gi:gg};
      const ni=ci+d, nc=clips[ni]; if(!nc||nc.mislukt) return null;
      if(!nc.mp4) return {ci:ni,gi:-1};          /* nog niet binnen: die clip is nu een wens */
      return {ci:ni, gi: d>0 ? 0 : nc.mp4.gops.length-1};
    };
    lijst.push({ci:wilClip,gi:g0});
    let p={ci:wilClip,gi:g0};
    for(let k=0;k<VOOR;k++){ p=p&&stap(p.ci,p.gi,richting); if(p) lijst.push(p); }
    p={ci:wilClip,gi:g0};
    for(let k=0;k<ACHTER;k++){ p=p&&stap(p.ci,p.gi,-richting); if(p) lijst.push(p); }
    return lijst;
  }
  /* Een groep is "gedaan" zodra hij één keer gedecodeerd is, ook als de decoder een
     beeld schuldig bleef: kies() pakt dan het buurbeeld. Zou dit op de aanwezigheid
     van élk beeld toetsen, dan werd zo'n groep eindeloos opnieuw gedecodeerd en kwam
     niets anders meer aan de beurt. */
  function groepAanwezig(c,gi){ return !!c.gopKlaar[gi]; }
  function groepBinnen(c,gi){ const g=c.mp4.gops[gi], l=g.tot-1; return c.mp4.offsets[l]+c.mp4.groottes[l]<=c.ontvangen; }

  async function decodeerGroep(c,gi){
    const m=c.mp4, g=m.gops[gi];
    if(!decoder||decoder.state==='closed') nieuweDecoder();
    const sleutel=m.codec+':'+m.breed+'x'+m.hoog+':'+m.beschrijving.join(',');
    if(cfgSleutel!==sleutel){
      const cfg={codec:m.codec,description:m.beschrijving,codedWidth:m.breed,codedHeight:m.hoog};
      if(VideoDecoder.isConfigSupported){ const r=await VideoDecoder.isConfigSupported(cfg); if(!r||!r.supported) throw new Error('codec niet ondersteund: '+m.codec); }
      decoder.configure(cfg);
      cfgSleutel=sleutel;
    }
    uitvoer=[]; uitvoerVoor={c,m};
    const t0=performance.now(); if(stat.laatste===c.i+':'+gi) stat.herhaald++; stat.laatste=c.i+':'+gi;
    const u8=new Uint8Array(c.buf);
    for(let s=g.van;s<g.tot;s++){
      decoder.decode(new EncodedVideoChunk({type:m.key[s]?'key':'delta',timestamp:m.pts[s],duration:m.dur[s],
        data:u8.subarray(m.offsets[s],m.offsets[s]+m.groottes[s])}));
    }
    await decoder.flush();
    const klaar=uitvoer; uitvoer=[]; uitvoerVoor=null;
    await Promise.all(klaar);
    if(c.gopKlaar) c.gopKlaar[gi]=1;
    { const dt=performance.now()-t0; stat.tijden.push(dt); if(stat.tijden.length>90) stat.tijden.shift(); stat.gopSec=Math.max(stat.gopSec||0,(g.beeldTot-g.beeldVan)*((CLIPS[c.i]&&CLIPS[c.i].sec)||5)/m.N);   /* de volle groep, niet een korte laatste */ } stat.gops++; stat.ms+=performance.now()-t0; stat.tekort+=(g.beeldTot-g.beeldVan)-klaar.length;
  }
  function ruimOp(){
    const houden=new Set(wensen().map(w=>w.ci+':'+w.gi));
    for(const c of clips){
      if(!c.mp4) continue;
      for(let gi=0;gi<c.gopKlaar.length;gi++) if(c.gopKlaar[gi]&&!houden.has(c.i+':'+gi)) c.gopKlaar[gi]=0;
      /* het laatst getekende beeld blijft altijd staan: bij een grote sprong (scrollbalk
         slepen) loopt de decoder achter en zonder dit beeld viel het doek terug op de
         poster, midden in de clip */
      for(const nr of [...c.cache.keys()]) if(!houden.has(c.i+':'+gopVan(c,nr)) && !(laatst&&laatst.c===c&&laatst.nr===nr)){
        const it=c.cache.get(nr); if(it&&it.bitmap) it.bitmap.close(); if(it&&it.frame) it.frame.close();
        c.cache.delete(nr); c.heeft[nr]=0;
      }
    }
  }
  async function werk(){
    if(bezig||dood) return; bezig=true;
    try{
      for(let ronde=0;ronde<400;ronde++){
        const c=clips[wilClip];
        /* de clip van nu is nog niet (ver genoeg) binnen: laden aanzetten en wachten
           tot de stroom ons opnieuw wekt — niet hier blijven hangen */
        if(!c.mp4){ if(!c.mislukt){ opVerzoek=c; laad(c); } break; }
        const w=wensen();
        const taak=w.find(x=>{ const cc=clips[x.ci]; return cc.mp4 && x.gi>=0 && !groepAanwezig(cc,x.gi) && groepBinnen(cc,x.gi); });
        if(!taak){
          /* een gewenste clip die nog niet binnenkomt aanzetten, hooguit één tegelijk:
             twee verzoeken naast de achtergrondlus delen dezelfde lijn en dan komt
             de clip die je ziet juist later */
          const open=w.map(x=>clips[x.ci]).find(cc=>!cc.mp4&&!cc.mislukt&&!cc.laadt);
          if(open && !(opVerzoek&&opVerzoek.laadt&&opVerzoek!==open)){ opVerzoek=open; laad(open); }
          break;
        }
        await decodeerGroep(clips[taak.ci],taak.gi);
        ruimOp();
      }
    }catch(e){ if(!gesloten){ console.warn('[vlucht] decoderen mislukt, terug naar video',e); dood=true; } }
    bezig=false;
  }

  function stel(c,binnen,v){
    const cl=clips[CLIPS.indexOf(c)]; if(!cl) return;
    /* met hysterese: de veer wisselt bij het uitdempen een paar keer van teken, en
       elke wissel zou anders een groep weggooien en een andere decoderen */
    if(v>0.02) richting=1; else if(v<-0.02) richting=-1;
    if(!gestart&&(cl.i>0||binnen>0.02)) gestart=true;
    const N=cl.mp4?cl.mp4.N:Math.round((c.sec||5)*FPSL(laag));
    const nr=Math.min(N-1,Math.max(0,Math.floor(binnen*N)));
    if(cl.i!==wilClip||nr!==wilNr){ wilClip=cl.i; wilNr=nr; }
    werk();
  }
  /* het dichtstbijzijnde beeld dat er is; liever het vorige houden dan flikkeren */
  function kies(){
    const c=clips[wilClip];
    if(c.heeft&&c.mp4){
      if(c.heeft[wilNr]) return {c,nr:wilNr};
      for(let d=1;d<=48;d++){
        if(wilNr-d>=0&&c.heeft[wilNr-d]) return {c,nr:wilNr-d};
        if(wilNr+d<c.mp4.N&&c.heeft[wilNr+d]) return {c,nr:wilNr+d};
      }
    }
    return null;
  }
  function tekenItem(it){
    if(it.leeg) return;
    if(it.frame){ cover(it.frame,it.bw,it.bh); return; }
    if(it.bitmap){ cover(it.bitmap,it.bw,it.bh); return; }
    let f; try{ f=new VideoFrame(it.data,it.init); }catch(e){ dood=true; throw e; }
    try{ cover(f,it.bw,it.bh); }catch(e){ dood=true; throw e; } finally{ f.close(); }
  }
  let getekend=null;   /* wat er nu op het doek staat: {c,nr,w,h} */
  function zet(k){
    const it=k.c.cache.get(k.nr); if(!it) return false;
    /* het doek houdt zijn beeld; hetzelfde beeld op dezelfde maat opnieuw tekenen is
       zestig keer per seconde werk voor niets, ook als er niet gescrold wordt */
    if(getekend&&getekend.c===k.c&&getekend.nr===k.nr&&getekend.w===vakW&&getekend.h===vakH) return true;
    ankerClip=k.c.i; ankerT=k.nr/Math.max(1,k.c.mp4.N-1);
    const t0=performance.now(); tekenItem(it); stat.tekenMs+=performance.now()-t0; stat.tekenN++;
    getekend={c:k.c,nr:k.nr,w:vakW,h:vakH}; return true;
  }
  function teken(){
    const k=kies();
    if(k&&zet(k)){ laatst=k; ladenUit(); return true; }
    /* niets van deze clip binnen: het laatst getekende beeld houden; de poster alleen
       zolang er nog nooit een beeld heeft gestaan */
    if(laatst&&zet(laatst)) return true;
    /* een vervangende motor (na de wissel naar de kleine clips) laat het laatste beeld
       van zijn voorganger staan in plaats van de poster te tonen */
    if(!laatst && !opties.zonderPoster){ const p=poster(clips[wilClip]); if(p){ cover(p,p.naturalWidth,p.naturalHeight); getekend=null; ladenUit(); return true; } }
    return false;
  }
  return {
    naam:'decoder', stel, teken, sluit,
    get dood(){ return dood; },
    meet(){ const k=kies(); return {beeld:k?k.nr*((CLIPS[k.c.i]&&CLIPS[k.c.i].sec)||5)/k.c.mp4.N:null, beeldId:k?k.c.i+':'+k.nr:(laatst?'l'+laatst.c.i+':'+laatst.nr:'poster'), stat:{...stat, cache:clips.reduce((a,c)=>a+c.cache.size,0), geladen:clips.filter(c=>c.mp4).length, laadt:clips.map(c=>c.laadt?'~':(c.mp4?'ok':(c.mislukt?'x':'-'))).join('')}}; }
  };
}

/* ---- motor 2: het <video>-pad (ongewijzigd, als terugval) ---- */
function maakVideoFilm(){
  CLIPS.forEach((c,i)=>{
    const v=document.createElement('video');
    v.src=c.src;v.muted=true;v.playsInline=true;v.crossOrigin='anonymous';
    /* Alleen de eerste twee clips volledig voorladen. Alle zes op 'auto' zetten haalt
       ruim 25 MB tegelijk binnen en laat zes decoders om dezelfde bandbreedte vechten;
       dat is op zichzelf al genoeg om de vlucht te laten stokken. regelClips() zet de
       volgende op 'auto' zodra je in de buurt komt. */
    v.preload = i<2 ? 'auto' : 'metadata';
    filmvak.appendChild(v);c.v=v;
    if(i>0) v.setAttribute('data-uit','');
    v.addEventListener('loadedmetadata',()=>{c.dur=v.duration;c.bw=v.videoWidth;c.bh=v.videoHeight;});
    if(i<2) v.play().then(()=>v.pause()).catch(()=>{});
  });
  let zoekLoopt=false, zoekTimer=0, actief=null, zoekMislukt=0;
  const SPRONG=1.2, RAAK=0.04;
  let modus='spelen', stokFrames=0, vorigeTijd=-1;
  function volgFilm(c){
    const v=c.v, t=c.wil;
    if(t==null||!c.dur) return;
    const gat=t-v.currentTime;
    if(Math.abs(gat)<=RAAK){ if(!v.paused) v.pause(); return; }
    if(modus==='spelen' && gat>0 && gat<SPRONG){
      v.playbackRate=Math.min(4,Math.max(0.3,gat*3.2));
      if(v.paused) v.play().catch(()=>{});
      if(!v.paused){
        if(Math.abs(v.currentTime-vorigeTijd)<1e-4){ if(++stokFrames>36){ modus='springen'; stokFrames=0; } }
        else stokFrames=0;
        vorigeTijd=v.currentTime;
      }
      return;
    }
    if(!v.paused) v.pause();
    zoekVerder();
  }
  function zoekVerder(){
    if(zoekLoopt) return;
    const c=actief;
    if(!c||!c.dur||c.wil==null) return;
    const t=c.wil;
    if(Math.abs(c.v.currentTime-t)<0.021) return;
    if(!inBuffer(c.v,t)) return;
    zoekLoopt=true;
    const af=()=>{ clearTimeout(zoekTimer); zoekLoopt=false; zoekMislukt=0; };
    c.v.addEventListener('seeked',af,{once:true});
    zoekTimer=setTimeout(()=>{
      c.v.removeEventListener('seeked',af); zoekLoopt=false;
      if(++zoekMislukt>=3){ modus='spelen'; zoekMislukt=0; vorigeTijd=-1; stokFrames=0; }
    },320);
    try{ c.v.currentTime=t; }
    catch(e){ clearTimeout(zoekTimer); zoekLoopt=false; }
  }
  function inBuffer(v,t){
    const b=v.buffered;
    for(let i=0;i<b.length;i++) if(t>=b.start(i)-0.1 && t<=b.end(i)+0.001) return true;
    return false;
  }
  function regelClips(actieveIndex){
    CLIPS.forEach((c,i)=>{
      const dichtbij=Math.abs(i-actieveIndex)<=1;
      if(c.v.preload!=='auto' && dichtbij) c.v.preload='auto';
      if(i!==actieveIndex && !c.v.paused) c.v.pause();
      if(i===actieveIndex) c.v.removeAttribute('data-uit'); else c.v.setAttribute('data-uit','');
    });
  }
  CLIPS.forEach(c=>{
    const kijk=()=>{ if(c.v.readyState>=2) ladenUit(); };
    c.v.addEventListener('loadeddata',kijk,{once:true}); kijk();
  });
  return {
    naam:'video',
    stel(c,binnen){
      if(c!==actief){ actief=c; regelClips(CLIPS.indexOf(c)); }
      c.wil=Math.max(0,binnen*(c.dur||5)-0.02);
      volgFilm(c);
    },
    teken(){
      const c=actief; if(!c) return false;
      if(c.v.readyState>=2){ cover(c.v, c.v.videoWidth||c.bw||1280, c.v.videoHeight||c.bh||716); return true; }
      return false;
    },
    get dood(){ return false; },
    meet(){ const c=actief; return {beeld:c?c.v.currentTime:null, beeldId:c?CLIPS.indexOf(c)+':'+c.v.currentTime.toFixed(4):null}; }
  };
}

/* ook bij verminderde beweging: deze motor hoeft niet af te spelen, en het videopad kan
   op een iPhone niet scrubben. ?vluchtvideo dwingt het videopad af, om te vergelijken. */
let film = !location.search.includes('vluchtvideo') ? maakDecoderFilm() : null;
if(!film){ naar24(); film=maakVideoFilm(); }
/* loopt motor 1 stuk, dan neemt motor 2 het over — de lus mag nooit zonder beelden zitten */
function huidigeFilm(){
  if(film.dood){ console.warn('[vlucht] terug naar het videopad'); try{ film.sluit&&film.sluit(); }catch(e){} naar24(); film=maakVideoFilm(); }
  return film;
}
/* TERUGSTAPPEN ALLEEN ALS HET ECHT NODIG IS.
   De motor meet per keyframegroep (12 beelden, een halve seconde film) hoe lang decoderen
   en bewaren duurt. Gemeten 25-09-2026: een M2 doet een groep van de grote laag in 60 tot
   80 ms; pas vanaf zo'n 250 ms per groep (een viermaal tragere processor) loopt het beeld
   bij snel scrollen zichtbaar achter. De eerste versie stapte op 110 ms (gemiddelde van
   drie groepen) terug en zette een druk maar sterk toestel op 960 pixels.
   Nu: de mediaan van steeds zes nieuwe groepen (één uitschieter door een ander tabblad
   telt niet); twee vensters achter elkaar boven GRENS_MS is een trede terug, boven twee
   keer de grens meteen twee. Bij het laden, vóór de vlucht in beeld is, mag één venster
   van drie groepen al beslissen, maar alleen boven twee keer de grens. Na veertig groepen
   staat de laag vast. WebKit stapt nooit terug: daar blijft het beeld op de GPU en liep
   ook de grote laag soepel. Een trede terug wordt voor dit tabblad onthouden. */
const GRENS_MS=200;
let laagBesloten=false, gezien=0, teTraag=0;
function mediaan(r){ const a=r.slice().sort((x,y)=>x-y), m=a.length>>1; return a.length%2?a[m]:(a[m-1]+a[m])/2; }
/* DE BRUG. Een nieuwe film heeft nog geen beeld en toont bewust geen poster, en een
   canvas dat van formaat verandert (andere DPR, of later de adresbalk) wordt zwart. Dus:
   vóór de wissel een kopie van wat er staat, en die tekent de lus zolang de nieuwe film
   niets heeft (review 25-09: "na een laagwissel wordt het doek zwart"). */
let overbrug=null, lijnGestapt=false;
function wissel(nieuw,reden){
  if(!nieuw||nieuw===laag) return;
  console.warn('[vlucht] laag '+laag+' -> '+nieuw+' ('+reden+')');
  if(!overbrug&&doek.width&&doek.height){
    try{ overbrug=document.createElement('canvas'); overbrug.width=doek.width; overbrug.height=doek.height; overbrug.getContext('2d').drawImage(doek,0,0); }catch(e){ overbrug=null; }
  }
  laag=nieuw; zetBronnen(); gezien=0; teTraag=0;
  /* het doek volgt de bronhoogte van de nieuwe laag, omhoog én omlaag */
  if(!dprParam){ const nd=doekDPR(nieuw); if(Math.abs(nd-DPR)>0.01){ DPR=nd; vakW=0; doekMaat(Math.round(W),Math.round(H)); } }
  if(overbrug){ try{ cover(overbrug,overbrug.width,overbrug.height); }catch(e){} }
  try{ film.sluit&&film.sluit(); }catch(e){}
  film=maakDecoderFilm({zonderPoster:true,vervang:true})||(naar24(),maakVideoFilm());
}
function stapTerug(nieuw,reden){
  try{ sessionStorage.setItem('donq-vlucht-trede-'+vorm,nieuw); }catch(e){}
  wissel(nieuw,reden);
}
function wisselLaag(){
  if(laagBesloten||film.naam!=='decoder') return;
  const st=film.meet().stat; if(!st) return;
  const t=TREDEN[vorm].filter(HEEFT), i=t.indexOf(laag);
  if(i<0||i>=t.length-1){ laagBesloten=true; return; }
  /* 1. DE LIJN. Haalt de echte doorvoer de bitrate van deze laag niet met 20% marge, dan
     loopt het beeld bij scrollen vast op beelden die nog niet binnen zijn. Beslissen op
     twee gemeten clips, of op één zodra de vlucht begonnen is (een enkele meting tijdens
     het laden van de pagina deelt de lijn met de rest van de pagina). */
  /* één meting mag al beslissen als de lijn duidelijk te traag is (onder 80% van wat de laag vraagt): dan valt
     de wissel vóór de vlucht en niet midden erin, waar hij een stilstand geeft terwijl de nieuwe laag laadt */
  /* na een eerdere wissel op de lijn geldt geen 20% marge meer, anders wisselt een lijn die net boven de
     nieuwe laag zit nóg een keer (gemeten 26-09: 60 Mbit/s ging groot -> groot24 -> grootLicht) */
  /* staand is de enige stap omlaag naar 480 pixels breed, en die ziet er op een telefoon slecht uit: daar
     alleen als de lijn echt te traag is (onder 75% van wat de laag vraagt), niet al bij 120% */
  const marge=vorm==='staand'?0.75:lijnGestapt?1.0:1.2;
  if(st.doorvoer&&st.nodig&&st.doorvoer<marge*st.nodig&&(st.metingen>=2||glad>=REIS_TOT*0.30||st.doorvoer<0.8*st.nodig)){
    /* meteen de hoogste lagere laag die op deze lijn past, niet trede voor trede (review 26-09) */
    let j=i+1; while(j<t.length-1&&MBIT[t[j]]&&st.doorvoer<1.2*MBIT[t[j]]) j++;
    lijnGestapt=true;
    stapTerug(t[j],'lijn '+st.doorvoer.toFixed(1)+' Mbit/s, laag vraagt '+st.nodig.toFixed(1)); return;
  }
  /* 2. HET DECODEREN, niet op WebKit (daar blijft het beeld op de GPU en liep ook groot soepel) */
  /* na 20 seconden film (niet 40 groepen: op 48 fps is dat maar 10 s) staat de laag vast */
  const filmSec=st.gops*(st.gopSec||0.5);
  if(WEBKIT||!st.tijden){ if(filmSec>=20) laagBesloten=true; return; }
  /* vroeg = nog vóór de film begint (glad onder het filmbegin, zie de voortgang hieronder) */
  const nieuwN=st.gops-gezien, vroeg=gezien===0&&glad<REIS_TOT*0.30;
  if(nieuwN<(vroeg?3:6)) return;
  const venster=st.tijden.slice(-Math.min(nieuwN,st.tijden.length)); gezien=st.gops;
  const m=mediaan(venster);
  /* de grens geldt per halve seconde film: bij 48 fps (groepen van een kwart seconde) is hij 100 ms */
  const G=GRENS_MS*Math.min(1,(st.gopSec||0.5)/0.5);
  /* twee treden pas als ook de 24 fps-trede van dezelfde maat te traag zou zijn (review 26-09: op 48 fps
     is 2G precies de gewone grens van groot24, dus een druk maar snel toestel ging meteen naar 1280) */
  const G2=Math.max(2*G,2*GRENS_MS);
  if(filmSec>=20&&m<G){ laagBesloten=true; return; }
  if(m<G){ teTraag=0; return; }
  if(vroeg&&m<2*G) return;
  teTraag++;
  if(!vroeg&&teTraag<2&&m<2*G) return;
  /* de volgende laag die echt minder decodeerwerk is (grootLicht kost evenveel als groot24 en wordt overgeslagen) */
  const lichter=k=>{ let j=k+1; while(j<t.length-1&&KOST(t[j])>=KOST(t[k])) j++; return Math.min(t.length-1,j); };
  let j=lichter(i); if(m>=G2&&j<t.length-1) j=lichter(j);
  stapTerug(t[j],Math.round(m)+' ms per groep (grens '+Math.round(G)+')');
}
/* DRAAIT DE TELEFOON, DAN WISSELT DE VORM: staand heeft alleen het midden van het beeld,
   dwars is het hele beeld nodig (en andersom is de liggende laag op een staand scherm
   verspilde pixels). Gedempt, want de adresbalk op een telefoon verandert de hoogte ook. */
let vormTimer=0, vormBreed=innerWidth;
addEventListener('resize',()=>{ clearTimeout(vormTimer); vormTimer=setTimeout(()=>{
  /* alleen de hoogte veranderd (adresbalk die in- of uitklapt): de vorm blijft */
  if(innerWidth===vormBreed) return; vormBreed=innerWidth;
  /* hysterese: staand vanaf 0,667, terug naar liggend pas boven 0,75 (review 25-09:
     iPhone SE en 16:9-telefoons schommelen met de werkbalk rond 0,667) */
  const r=innerWidth/Math.max(1,innerHeight);
  const v=vorm==='staand'?(r>0.75?'liggend':'staand'):((r<=STAAND_MAX&&STAANDE())?'staand':'liggend');
  /* het videopad (geen WebCodecs, of een gestorven decoder) wisselt niet: dat deed de oude motor ook niet */
  if(v===vorm||!film||film.naam!=='decoder') return;
  vorm=v; laagBesloten=false; wissel(beginLaag(v),'vorm '+v);
},450); },{passive:true});

/* ---------- scroll ---------- */
const scroller=()=>document.scrollingElement||document.documentElement;

/* DE VOORTGANG MEET DE VLUCHT, NIET DE PAGINA.
   Dit stond eerst op scrollTop gedeeld door de hele paginahoogte. Dat lijkt goed
   maar is het niet: hoe lang de rest van de pagina is bepaalt dan hoeveel scroll de
   vlucht krijgt. De platte kaart eronder is een paar duizend pixel lang, dus de
   vlucht besloeg 69% van de scroll bij een venster van 800 hoog — en de laatste
   dertig procent van de film speelde in het niets. Erger nog: elke halte stond op
   een percentage van de PAGINA, dus verschoof mee met een venster of met een plaatje
   dat later inlaadde.

   Nu meet hij de sectie zelf: 0 als zijn bovenkant het venster raakt, 1 als zijn
   onderkant het venster verlaat. Wat je in de editor op 40% zet, staat op 40% van
   de vlucht. */
const lees=()=>{
  const r=sectie.getBoundingClientRect();
  const reisbaar=sectie.offsetHeight-innerHeight;
  if(reisbaar<=0) return 0;
  return Math.min(1,Math.max(0,-r.top/reisbaar));
};

/* AL DIE LAGEN STAAN position:fixed, dus ze verdwijnen niet van het scherm als de
   sectie voorbij is — ze bleven de platte kaart onderaan de pagina volledig
   afdekken. Zodra de onderkant van de sectie het venster uit is, gaan ze uit. De
   film blijft dus nog één schermhoogte op het slotbeeld staan en maakt daarna
   plaats. */
/* DE AFSLUITING SCHUIFT ERONDERUIT OMHOOG. Alle lagen van de vlucht staan
   position:fixed; ze gingen pas weg als de hele sectie boven het venster uit was.
   Maar onder de vlucht staat alleen nog de afsluiting en de footer, en die zijn
   samen korter dan een scherm: de sectie kón dus nooit helemaal uit beeld, en de
   laatste halte bleef over de knoppen en de footer hangen (Armyan, 15-09-2026:
   "het laatste stukje glitcht"). Nu vervagen de lagen zodra de onderkant van de
   sectie in beeld komt, over de eerste 260 px dat de afsluiting omhoogschuift. */
/* DE OVERGANG NAAR DE MENSEN (Armyan, 26-09-2026: "die overgang van laatste stukje beeld naar mensen,
   kan dat beter en meer dynamisch"). Tot nu toe vervaagde de film over 260 px naar het donkere vlak van
   de sectie, en daarna stond je een halve schermhoogte naar leeg donkergroen te kijken voordat de
   volgende sectie kwam. Nu blijft de film staan en wordt hij BEDEKT: de volgende sectie schuift er als
   een vlak overheen (met de geverfde snede als bovenrand, zie donq.css), terwijl de film iets wegzakt
   en donkerder wordt. dekking: 0 = de volgende sectie is nog onder het venster, 1 = hij vult het scherm.
   Alleen de teksten en de kaartlaag vervagen nog snel (uitrol, over 260 px). */
let uitrol=0, dekking=0;
const volgende=(()=>{ const w=sectie.closest('.shopify-section'); return w&&w.nextElementSibling; })();
function stemZichtAf(){
  const r=sectie.getBoundingClientRect();
  uitrol=Math.min(1,Math.max(0,(innerHeight-r.bottom)/260));
  dekking=Math.min(1,Math.max(0,(innerHeight-r.bottom)/innerHeight));
  sectie.classList.toggle('is-weg', dekking>=1 || r.top>=innerHeight);
  sectie.style.setProperty('--uitrol',(1-uitrol).toFixed(3));
  sectie.style.setProperty('--dekking',dekking.toFixed(4));
  if(volgende) volgende.style.setProperty('--binnen',soepel(dekking).toFixed(4));
}
const soepel=x=>x<0?0:x>1?1:x*x*(3-2*x);
const meng=(a,b,t)=>a+(b-a)*t;

let doel=0,glad=0,snelheid=0,meetWil={clip:-1,wil:null};
/* meetpunt voor audit-2026-09-14/kaart-beelden/reeks/meet.mjs; kost niets */
window.__vl={get laag(){return laag},get glad(){return glad},get wil(){return meetWil.wil},get clip(){return meetWil.clip},
  get beeld(){return film.meet().beeld},get beeldId(){return film.meet().beeldId},get motor(){return film.naam},get stat(){return film.meet().stat||null}};

/* HOE DE AFSPEELKOP DE SCROLL VOLGT.
   Eerst kroop hij naar het doel toe: glad += (doel-glad)*0.055. Dat remt wel af,
   maar alleen zolang er nog gat te overbruggen is — stop je met scrollen, dan is
   het gat op en staat hij meteen stil. Je ziet dan de laatste beelden als losse
   standen langsschuiven.

   Nu is het een VEER MET SNELHEID. Het doel trekt aan de kop, de kop houdt zijn
   snelheid en die wordt afgeremd. Stop je met scrollen, dan vaart hij nog ruim een
   halve seconde door en dempt uit — de beelden remmen zichtbaar af in plaats van
   te blokkeren. Dat is de traagheid van een drone die niet op de rem gaat.

   Stijfheid 0,06 met demping 0,68: 0,42 s uitrollen, 6,7% naveren, en een
   achterstand van 7,8 beelden tijdens het scrollen in plaats van 11,4. Dus hij
   plakt strakker aan je vinger én rolt nog uit. Slapper afstemmen voelt zelf als
   vertraging — dat is óók iets wat "laggy" oplevert. */
/* Dezelfde veer, maar op de klok in plaats van per schermverversing: 0,06/0,68 per
   beeld op 60 Hz is k=147, c=19,2 per seconde. Op een 120 Hz-scherm was hij anders
   twee keer zo stijf en op een haperend scherm slap. */
const VEER_K=147, VEER_C=19.2;
const LAND=0.86;
let vorigeTik=0;   /* hier is de film uit; de rest van de vlucht is de aankomst */

/* DE LUS MAG NOOIT KUNNEN STOPPEN. Alles hieronder loopt in requestAnimationFrame,
   en gooit iets daarbinnen een fout, dan wordt de volgende frame nooit aangevraagd
   en staat het beeld voorgoed stil — precies wat "het loopt helemaal vast" is. Een
   video die halverwege een seek van bron wisselt is genoeg. Daarom vragen we de volgende frame
   ALTIJD aan, wat er ook gebeurt, en melden een fout één keer in de console. */
let gemeld=false;
function frame(t){
  try{ teken(t||performance.now()); }
  catch(e){ if(!gemeld){ gemeld=true; console.warn('[vlucht] overgeslagen frame:',e); } }
  requestAnimationFrame(frame);
}
function teken(t){
  doel=lees();
  stemZichtAf();
  const dt=Math.min(1/30,Math.max(1/240,vorigeTik?(t-vorigeTik)/1000:1/60));
  /* de eerste tik begint op de scrollstand zelf: een herlaad halverwege of een anker
     mag niet vanaf nul door alle clips heen vliegen en ze allemaal laten laden */
  if(!vorigeTik){ glad=doel; snelheid=0; }
  vorigeTik=t;
  if(rustig){ glad=doel; snelheid=0; }
  else{
    snelheid+=(VEER_K*(doel-glad)-VEER_C*snelheid)*dt;
    glad+=snelheid*dt;
    if(glad<0){glad=0;snelheid=0;} else if(glad>1){glad=1;snelheid=0;}
  }

  /* ---- DE REIS OVER DE LIJN: groeien, meezakken en kantelen tegelijk ---- */
  const g=Math.min(1,glad/REIS_TOT);
  tekenRail(glad, jaarEl ? jaarEl.__t : null);

  /* de lijn tekent zichzelf naar beneden */
  const totaalLen=stroomdelen.reduce((a,s)=>a+s.len,0);
  let ged=g*totaalLen, punt=null;
  for(const sd of stroomdelen){
    const deel=Math.min(1,Math.max(0,ged/Math.max(1,sd.len)));
    sd.paden.forEach(p=>p.style.strokeDashoffset=(sd.len*(1-deel)).toFixed(1));
    /* het eerste stuk dat nog niet af is, is waar de punt staat — daar loopt hij */
    if(punt===null && deel<1 && sd.len>0) punt=sd.paden[0].getPointAtLength(sd.len*deel);
    ged-=sd.len;
  }
  if(ezelOp){
    if(!punt){ const l=stroomdelen[stroomdelen.length-1];
      if(l&&l.len>0) punt=l.paden[0].getPointAtLength(l.len); }
    if(punt) ezelOp.setAttribute('transform',
      `translate(${punt.x.toFixed(1)} ${punt.y.toFixed(1)}) scale(0.78) translate(-60 -88)`);
    /* Het ezeltje zit in het kaartvlak en werd dus mee opgeschaald en gekanteld
       tot een uitgesmeerde reus over de eerste luchtfoto. Zodra het vlak begint
       te kantelen neemt de zijrail zijn rol over; hier lost hij op. */
    ezelOp.style.opacity=(1-soepel(Math.min(1,g/0.28))).toFixed(3);
  }
  /* De knopen stonden op dekking 0 tot je erlangs kwam. Samen met een lijn van
     lengte nul was er dus niets. Ze staan nu vaag klaar en lichten op zodra je ze
     bereikt — de CSS-overgang van een halve seconde doet het werk. */
  knoopEls.forEach((kn,i)=>{ kn.style.opacity = g > (i+0.55)/HALTES.length ? '1':'0.26'; });

  /* DE CAMERA VOLGT DE PUNT. De getekende punt staat op g × de hoogte van het
     vlak; we schuiven het vlak zo op dat die punt op ongeveer de helft van het
     scherm blijft. Daardoor daal je mee met de lijn in plaats van hem van boven
     te zien volschieten. */
  const vlakH = kaartvlak.clientWidth * (2300/900);
  const volg  = (H*0.48) - (g*vlakH) - H*0.05;

  /* HET KANTELEN, IN TWEE ETAPPES.

     Eerste etappe: van recht op de kaart kijken naar schuin naar beneden kijken.
     Die mag uitdempen — je komt ergens aan.

     Tweede etappe: van naar beneden kijken naar VOORUIT kijken, zoals een drone
     die zich waterpas legt. Die loopt bewust LINEAIR door tot het einde, zonder
     uit te dempen. Met één gladgestreken curve over het geheel kwam de camera
     tot schuin-omlaag en bleef daar hangen; dat was precies wat er niet klopte.

     De laatste graden zijn het belangrijkst: tussen 80 en 88 graden gaat het van
     "ik kijk op een vlak" naar "ik kijk over een horizon". */
  const kantA = soepel(Math.min(1, g/0.40));                 /*  0 -> 55 graden, sneller dan eerst */
  const kantB = Math.min(1, Math.max(0, (g-0.45)/0.55));     /* 55 -> 88 graden */
  const kant  = kantA*55 + kantB*33;
  /* het vluchtpunt stijgt mee naar de horizon terwijl je waterpas gaat */
  kaartlaag.style.perspectiveOrigin = `50% ${(40+kantB*14).toFixed(1)}%`;
  kaartvlak.style.transform=
    `translateY(${volg.toFixed(1)}px) scale(${(1+kantA*0.55+kantB*0.5).toFixed(3)}) rotateX(${kant.toFixed(2)}deg)`;
  kaartvlak.style.opacity=(1-soepel(Math.max(0,(g-0.55)/0.45))).toFixed(3);
  kaartkop.style.opacity=(1-soepel(Math.min(1,g/0.35))).toFixed(3);

  /* ---- de film komt op, schermvullend, en zakt dan in zijn kader ---- */
  /* de film komt op vanaf 30% van de reis, zodat er geen leeg scherm blijft staan */
  /* EERDER INLOPEN. De film kwam pas op 30% van de reis over de lijn; tot die tijd
     was het scherm een vage kop met een lijntje. Nu begint hij op 10% en is hij op
     50% vol, zodat het eerste scherm meteen ergens over gaat. */
  const film=soepel(Math.max(0,(g-0.10)/0.40));
  /* De film blijft schermvullend — hij is de wereld waar je in zit, geen
     illustratie in een kadertje. De tekst krijgt het kader. */
  filmvak.style.left='0px'; filmvak.style.top='0px';
  filmvak.style.width=W+'px'; filmvak.style.height=H+'px';
  /* de film blijft vol staan tot hij bedekt is, en zakt ondertussen 16% van een scherm weg: diepte zonder
     schaal (ontwerpregel: nooit scale op een beeld) en zonder dat er onder de film iets leeg wordt */
  filmvak.style.opacity=film.toFixed(3);
  filmvak.style.transform=(dekking>0&&!rustig)?`translate3d(0,${(-0.16*H*soepel(dekking)).toFixed(1)}px,0)`:'';
  doekMaat(Math.round(W),Math.round(H));
  hud.style.opacity=(film*(1-uitrol)).toFixed(3);

  /* welk frame ---- */
  /* de film begint te lopen op het moment dat hij begint op te komen, zodat het
     eerste frame al klopt met wat de kaart op dat moment laat zien */
  /* De film begint al op 30% van de reis over de kaartlijn. Op 60% bleef er te
     lang een bijna leeg scherm staan met alleen een dunne lijn erop; nu loopt de
     film al terwijl de kaart nog kantelt, en overlappen ze elkaar echt. */
  const start=REIS_TOT*0.30;
  /* DE AANKOMST. De film liep tot het eind van de vlucht door, en meteen daarna
     begon de platte kaart — je vloog zevenduizend jaar en kreeg toen dezelfde
     zevenduizend jaar nog eens als stilstaand plaatje. Nu is de film op 86% klaar
     en houdt de laatste 14% het slotbeeld vast: je blijft boven zijn schouders
     hangen terwijl daar het verhaal van DonQ verteld wordt. Dát is het heden. */
  const vp=Math.min(1,Math.max(0,(glad-start)/(LAND-start)));
  let c=CLIPS[CLIPS.length-1];
  for(const q of CLIPS){ if(vp>=q.van&&vp<q.tot){ c=q; break; } }
  const binnen=Math.min(1,Math.max(0,(vp-c.van)/(c.tot-c.van)));
  /* de motor zet het gewenste beeld klaar en tekent het beste dat er nú is; het
     canvas blijft altijd gevuld, ook terwijl er nog gedecodeerd of geladen wordt */
  if(!laagBesloten) wisselLaag();
  try{ const fm=huidigeFilm(); fm.stel(c,binnen,snelheid);
    if(fm.teken()){ if(overbrug){ overbrug.width=overbrug.height=0; overbrug=null; } }
    else if(overbrug) cover(overbrug,overbrug.width,overbrug.height); }
  catch(e){ if(!gemeld){ gemeld=true; console.warn('[vlucht] film:',e); } }
  meetWil={clip:CLIPS.indexOf(c),wil:binnen*c.sec};
  /* ---- haltes ---- */
  /* OP EEN SMAL SCHERM MAG ER MAAR EEN TEGELIJK STAAN.
     Op breed scherm staat elke halte op zijn eigen plek en mogen er twee door
     elkaar heen vloeien - dat leest als een overgang. Op een telefoon staan ze
     allemaal op dezelfde plek onderaan, en dan vallen twee half-zichtbare
     kaders exact over elkaar en is geen van beide meer te lezen.
     Daarom hier: bepaal welke het dichtst bij is, en zet de rest hard op nul. */
  const smal = innerWidth < 900;
  let winnaar = -1, beste = -1;
  if (smal) {
    HALTES.forEach((h2,i)=>{
      const z = Math.max(0, 1 - Math.abs(glad - h2.p) / 0.030);
      if (z > beste) { beste = z; winnaar = i; }
    });
  }
  HALTES.forEach((h2,i)=>{
    /* Hoe lang een halte in beeld blijft. Stond op 0,036 toen de haltes nog negen
       tot elf procentpunten uit elkaar lagen. Nu staan ze dichter op elkaar — elke
       halte hoort op zijn eigen tijdperk in de film te vallen — dus moet het
       venster mee omlaag, anders overlappen twee tekstkaders elkaar. 0,030 komt
       neer op ±0,9 seconde film, en het kleinste gat is 2,1 s. */
    let zicht=Math.max(0,1-Math.abs(glad-h2.p)/0.030);
    if (smal && i !== winnaar) zicht = 0;
    const el=halteEls[i];
    el.style.opacity=(zicht*(1-uitrol)).toFixed(3);
    /* een kader op nul mag geen scrollruimte of aanraking meer opeisen */
    el.style.visibility = zicht < 0.02 ? 'hidden' : 'visible';
    const dy2=(1-zicht)*22;
    /* op de telefoon staat elk kader onderaan vast (CSS); de -50% van de middenkaders
       schoof ze daar half buiten beeld (Armyan, 17-09: "niet juist gezet op telefoon") */
    el.style.transform = (el.dataset.midden && !smal)
      ? `translate(-50%, calc(-50% + ${dy2.toFixed(1)}px))`
      : `translateY(${dy2.toFixed(1)}px)`;
  });

  /* ---- hoogtemeter ---- */
  let a=HALTES[0],b=HALTES[HALTES.length-1];
  for(let i=0;i<HALTES.length-1;i++){if(glad>=HALTES[i].p&&glad<HALTES[i+1].p){a=HALTES[i];b=HALTES[i+1];break;}}
  const t2=Math.min(1,Math.max(0,(glad-a.p)/Math.max(1e-6,b.p-a.p)));
  const jj=a.getal+(b.getal-a.getal)*t2;
  zetTekst(jaarEl,jj<0?String(Math.round(-jj/10)*10):String(Math.round(jj)));
  zetTekst(tijdvakEl,jj<0?'voor Christus':'na Christus');
  zetStijl(balk,'width',(glad*100).toFixed(1)+'%');
  if(glad>0.01) wenk.classList.add('is-uit');
}
requestAnimationFrame(frame);

/* meetoverlay op een echt toestel: ?vluchtmeet (cijfers) of ?vluchtmeet=auto (scrolt zelf) */
if(/[?&]vluchtmeet/.test(location.search)&&document.currentScript){
  const m=document.createElement('script'); m.src=document.currentScript.src.replace('donq-vlucht.js','donq-vlucht-meet.js'); document.head.appendChild(m);
}
})();
